module.exports = __webpack_public_path__ + "img/carousel.79bbb24f.svg";